import { Injectable } from '@angular/core';
import { Plan } from '../../models/plan.model';
import { GoogleTagManagerService } from 'angular-google-tag-manager';
import { Product } from '../../models/product.model';

declare global {
  interface Window { dataLayer: any[]; }
}

@Injectable({
  providedIn: 'root'
})
export class DataLayerService {

  constructor(private gtmService: GoogleTagManagerService) { }
  
  onPushDataLayer(data: any){
    if(window) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(data);
    } else  {
      console.log('windows is undefined to push datalayer', data);
    }
  };

  pushTag(data: any){
    data = this.toLowerCaseAllProperties(data);
    this.gtmService.pushTag(data);
  };


  private timeSeries(value) {
    switch (value) {
      case 1:
        return 'mensual'
      case 6:
        return 'semestral'
      case 12:
        return 'anual'   
      default:
        return 'no aplica';
    }
  }

  private pushString(needle: string, string:string, words: string[]) {
    if(string.indexOf(needle) != -1) {
      words.push(needle);
    }

    return words;
  }
  private searchViewer(item: Plan | Product ) {
    let viewers: string[]= [];
    if(item.summary && typeof item.summary == "string") {
      viewers = this.pushString('3D', item.summary, viewers);
      viewers = this.pushString('360', item.summary, viewers);
    }

    if(item.summary && Array.isArray(item.summary)) {
      for (let index = 0; index < item.summary.length; index++) {
        const element = item.summary[index];
        viewers = this.pushString('3D', element, viewers);
        viewers = this.pushString('360', element, viewers);
      }
    }

    if(item.detailModal && item.detailModal.relevantCharacteristics && Array.isArray(item.detailModal.relevantCharacteristics)) {
      for (let index = 0; index < item.detailModal.relevantCharacteristics.length; index++) {
        const element = item.detailModal.relevantCharacteristics[index];
        viewers = this.pushString('3D', element, viewers);
        viewers = this.pushString('360', element, viewers);
      }
    }

    viewers = viewers.filter((item,index)=>{
      return viewers.indexOf(item) === index;
    })
    return viewers;
  }

  public pushTagByEventCar( item: Plan | Product,typeEvent: string, typeLabel: string = 'add', quantity: number = 1, homologateName = false) {
    const dimension38 = (item.summary && Array.isArray(item.summary)) ? item.summary as string[] : [];
    const dimension36 = (homologateName) ? item.name : '';
    const dimension35 = this.searchViewer(item);
    const product = {
      'name': item.name,     
      'id': item.id,        
      'price': item.priceDiscount,        
      'brand': 'ciencuadras',
      'category':  'producto', //item.detailModal.type,
      'variant': this.timeSeries(item.detailModal.validity),
      'quantity': quantity,
      'dimension24': 'productos',
      'dimension35': dimension35.join(' - '),  //pvisualizacioninmueble,
      'dimension36': dimension36, //pproductoadicionales,
      'dimension37': this.timeSeries(item.detailModal.validity), // pvigenciapublicacion,
      'dimension38':  dimension38.join(' - '),
      'dimension39': '' //ptipotransaccion,
    };
    
    let ecommer: any = {
      'currencyCode': 'COP',
      'add': {
        'actionField': {'list': 'productos'},
        'products': [product]
      }
    };

    if(typeLabel == 'remove') {
      ecommer = {
        'currencyCode': 'COP',
        'remove': {
          'products': [product]
        }
      };
    }

    const tag  = this.toLowerCaseAllProperties({
      'event': typeEvent,
      'ecommerce': ecommer
     });
    this.gtmService.pushTag(tag);
  }

  public pushTagEventClick(tag: EventClickTag) {
    tag = this.toLowerCaseAllProperties(tag);
    this.gtmService.pushTag(tag);
  }

  private toLowerCaseAllProperties(object) {
    for (const item in object) {
      if (typeof object[item] === "string") {
        object[item] = object[item].toLowerCase();
        object[item] = this.removeAccent(object[item]);
        object[item] = (object[item] === 'cop') ? object[item].toUpperCase() : object[item];
        object[item] = (object[item] === 'productimpression') ? 'productImpression' : object[item];
        object[item] = (object[item] === 'addtocart') ? 'addToCart' : object[item];
        object[item] = (object[item] === 'removefromcart') ? 'removeFromCart' : object[item];
        object[item] = (object[item] === 'productdetail') ? 'productDetail' : object[item];
        object[item] = (object[item] === 'productclick') ? 'productClick' : object[item];

        if(item === 'seccion' || item === 'dimension24' || item === 'list') {
          object[item] = this.getFirstPath(object[item]);
        }

        if(item === 'action' || item === 'title') {
          object[item] = this.toUpperCaseAction(object[item]);
        }

        if(object[item] === 'virtualpage') {
          object[item] = 'virtualPage'
        }
      }

      if (typeof object[item] === "object") {
        object[item] = this.toLowerCaseAllProperties(object[item]);
      }

      if(object[item] === null || object[item] === 'null') {
        object[item] = "";
      }
    }

    return object;
  }

  private removeAccent(text: string){
    return text.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  }

  private getFirstPath(url: string) {

    if(url.indexOf('/') !== -1) {
      const parts = url.split('/');
      return (parts[0] == "" && parts.length > 1) ? parts[1] : parts[0];
    }

    return url;

  }

  private toUpperCaseAction(text: string) {
    text =  text.replace('ccw', 'CCW');
    return text.replace('ccr', 'CCR');
  }
}

export interface EventClickTag {
  event: string,
  category: string,
  action: string,
  label: string
}
